// extracted by mini-css-extract-plugin
export var closed = "_9e-1";
export var resizer = "_9e-0";